
export enum ManaPostalDeliveryStepState
{
    Awaiting = "Awaiting",
    Delivered = "Delivered",
    Cancelled = "Cancelled"
}
